import script from "./MyPopover.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyPopover.vue?vue&type=script&lang=ts&setup=true"

import "./MyPopover.vue?vue&type=style&index=0&id=882dd1cc&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-882dd1cc"]])

export default __exports__